import { Component, Input } from '@angular/core';

@Component({
  selector: 'basic-card',
  imports: [],
  standalone: true,
  templateUrl: './basic-card.component.html'
})
export class BasicCardComponent {
  @Input() title!: string;
  @Input() subTitle!: string;
  @Input() bottomLeftText!: string;
  @Input() bottomLeftTextIcon!: string;
  @Input() bottomRightText!: string;
  @Input() bottomRightTextIcon!: string;
  @Input() cardIcon!: string;
  @Input() cardBgColor: string = 'white';
}
